<template>
  <div>
    <layout-sub-modulo>
      <template v-slot:title>Logs</template>

      <template v-slot:filtro>
        <v-container fluid class="pa-0">
          <v-row dense justify="center">
            <v-col class="mt-3" cols="12" sm="5" md="5">
              <v-autocomplete
                :items="companias"
                label="Compañia"
                v-model="compania"
                item-value="nitCompania"
                item-text="descCompania"
                @change="obtenerSucursales()"
                dense
                outlined
                clearable
              />
            </v-col>
            <v-col class="mt-3" cols="12" sm="5" md="5">
              <v-autocomplete
                :items="sucursales"
                label="Sucursal"
                v-model="sucursal"
                item-value="idSucursal"
                item-text="descripcionSucursal"
                dense
                outlined
                clearable
                :disabled="!compania"
              />
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col sm="12" md="2">
              <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                max-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaInicial"
                    label="Fecha Inicial"
                    append-icon="event"
                    readonly
                    dense
                    outlined
                    clearable
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="fechaInicial" no-title />
              </v-menu>
            </v-col>

            <v-col sm="12" md="2">
              <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                max-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaFinal"
                    label="Fecha Final"
                    append-icon="event"
                    readonly
                    dense
                    outlined
                    clearable
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="fechaFinal" no-title />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:body>
        <log-table :logs="logsFiltrados" />
      </template>
    </layout-sub-modulo>
  </div>
</template>

<script>
import empresaService from '../../../Services/empresaService';
import LayoutSubModulo from '../../../components/Layout/SubModulo.vue';
import logService from '../../../Services/logService';
import {
  formatDate,
  formatearFechaLocal,
} from '../../../utils/formatearFechaUtil';
import LogTable from './Table/LogTable.vue';

export default {
  name: 'LogEventos',

  components: {
    LayoutSubModulo,
    LogTable,
  },

  data() {
    return {
      dataLogs: [],
      compania: null,
      sucursal: null,
      companias: [],
      sucursales: [],
      fechaInicial: null,
      fechaFinal: null,
    };
  },

  computed: {
    logsFiltrados() {
      const { compania, sucursal, fechaInicial, fechaFinal } = this;
      const dataRaw = this.dataLogs;

      if (!compania && !sucursal && !fechaInicial && !fechaFinal) {
        return dataRaw;
      }

      return dataRaw.filter(log => {
        const cumpleCompania =
          !compania ||
          String(log.nitCompania).trim() === String(compania).trim();

        const cumpleSucursal =
          !sucursal ||
          String(log.idSucursal).trim() === String(sucursal).trim();

        const cumpleFecha =
          (!fechaInicial || log.fechaFiltro >= fechaInicial) &&
          (!fechaFinal || log.fechaFiltro <= fechaFinal);

        return cumpleCompania && cumpleSucursal && cumpleFecha;
      });
    },
  },

  created() {
    this.obtenerLogs();
    this.obtenerCompanias();
  },

  methods: {
    async obtenerCompanias() {
      const response = await empresaService.buscarTodos();

      this.companias = (response?.data ?? []).map(empresa => ({
        nitCompania: empresa.nit,
        descCompania: empresa.razon_social,
      }));
    },

    async obtenerSucursales() {
      this.sucursal = null;
      this.sucursales = [];

      if (!this.compania) {
        return;
      }

      const filtros = {
        nit: this.compania,
      };

      const response = await empresaService.buscarTodos(filtros);
      const empresa = response?.data?.[0];

      if (!empresa) {
        return;
      }

      this.sucursales = (empresa.sucursales ?? []).map(sucursal => ({
        idSucursal: sucursal.sucursal_id,
        descripcionSucursal: sucursal.descripcion_sucursal,
      }));
    },

    async obtenerLogs() {
      const response = await logService.buscarTodos();
      this.dataLogs = response.data.map(log => ({
        ...log,
        nitCompania: log.NitCompañia,
        descCompania: log.DescCompañia,
        idSucursal: log.IdSucursal,
        descripcionSucursal: log.DescripcionSucursal,
        fechaFiltro: formatearFechaLocal(log.Fecha),
        Fecha: formatDate(log.Fecha, true),
      }));
    },
  },
};
</script>

<style scoped></style>
